import { render, staticRenderFns } from "./AktivitasValidatorDialog.vue?vue&type=template&id=38431dae&"
import script from "./AktivitasValidatorDialog.vue?vue&type=script&lang=js&"
export * from "./AktivitasValidatorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports